const SITE_URL = 'https://coursepress.lnu.se'
const PATH_PREFIX = '/kurser/webbprogrammering-pa-klientsidan-ht25'

const config = {
  gatsby: {
    pathPrefix: PATH_PREFIX,
    siteUrl: SITE_URL,
    gaTrackingId: null
  },
  header: {
    logoLink: '/',
    title: 'logo-wordmark-sv.png',
    courseName: 'Webbprogrammering på klientsidan (1DV025)',
    links: [
      { text: 'GitLab', link: 'https://gitlab.lnu.se/1dv025' },
      { text: 'Zoom', link: `${SITE_URL}${PATH_PREFIX}/zoom` },
      { text: 'Moodle', link: 'https://moodle.lnu.se/course/view.php?id=68658'},
      { text: 'YouTube', link: 'https://www.youtube.com/cslnu' },
      { text: 'Schema', link: 'https://cloud.timeedit.net/lnu/web/schema2/riq61Q6X0w9Z59QyQ47559Y664ZY50525Y749ZgQ50o13Y8X79Z8QcbQwQQZhrnZqpQnc6cdmcmcZqbyo.html'}
    ]
  },
  sidebar: {
    frontline: false,
    ignoreIndex: true,
    startCollapsed: true
  },
  siteMetadata: {
    title: 'Linnéuniversitetet',
    courseCode: '1dv025',
    language: "sv",
    description: 'Documentation built with mdx. Powering learn.hasura.io ',
    ogImage: null
  }
}

module.exports = config
